import { config } from "./config.js";
import axios from "axios";
import Vue from "vue";

axios.defaults.baseURL = config.baseUrl;

class Http {
  constructor() {
    this.baseUrl = config.baseUrl;
    this.token = localStorage.getItem("TOKEN")
      ? localStorage.getItem("TOKEN")
      : "MinProgram";
    this.fillterUrl = [
      "WebApi/Details/GetEPDetails",
      "WebApi/Product/AddPrice2",
      "WebApi/OpenPage/MinProgramHomePage",
      "WebApi/Order/PayInfo",
      "WebApi/Payment/PayOrderQuery",
      "WebApi/Customer/MyOfferPrice"
    ];
  }

  /**
   *
   *
   * @param {*} {
   *     url,请求地址
   *     method 请求类型 默认post,
   *     param 请求参数 类型 object 默认为空,
   *     header 请求头 类型 object,
   *     loading 是否显示全局加载框 默认为false
   *   }
   * @returns
   * @memberof Http
   */
  request({
    url,
    method = "post",
    param = {},
    header = {
      Authorization:
        "Bearer " +
        (localStorage.getItem("TOKEN")
          ? localStorage.getItem("TOKEN")
          : "MinProgram")
    },
    load = false
  }) {
    let _this = this;
    let loading;
    if (!load) loading = _this.showLoading();
    return new Promise((resolve, reject) => {
      axios({
        method: method,
        url: url,
        data: param,
        headers: header
      }).then(function({ data }) {
        //需要验证StatusCode的接口加入过滤器列表就可以返回，其他接口按照正常只使用data处理
        loading && loading.close();
        if (_this._filterResults(url).length > 0) {
          if (data.success) {
            resolve(data);
          } else {
            //_this.showToast(data.errorMessage, "error");
            reject(data);
          }
        } else {
          if (data.success) {
            resolve(data.data);
          } else {
            _this.showToast(data.errorMessage, "error");
            reject(data.data);
          }
        }
      });
    });
  }

  _filterResults(url) {
    let results = [];
    this.fillterUrl.forEach(item => {
      if (url.indexOf(item) >= 0) {
        results.push(item);
      }
    });
    return results;
  }

  /**
   *
   *
   * @param {string} msg 错误提示
   * @param {string} type 错误类型 可选 success/warning/info/error
   * @memberof Http
   */
  showToast(msg, type) {
    Vue.prototype.$message({
      message: msg,
      type: type
    });
  }

  /**
   *
   *  加载框
   * @returns
   * @memberof Http
   */
  showLoading() {
    const loading = Vue.prototype.$loading({
      lock: true,
      text: "加载中",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    return loading;
  }
}

export { Http };
